export default "__VITE_ASSET__nxWvNOnq__"